import B2BSection from "@/components/B2BSection";
import Testimonials from "@/components/Testimonials";
import { FAQSection } from "@/components/FAQSection";
import { motion } from "framer-motion";
import { useTrackView } from "@/lib/trackInterest";

export default function B2BPage() {
  useTrackView("b2b", "B2B · Corporate Wellness");
  return (
    <main className="pt-32 md:pt-40">
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
          className="grid grid-cols-12 gap-y-8"
        >
          <div className="col-span-12 md:col-span-8">
            <div className="section-tag mb-4">§ Corporate Wellness</div>
            <h1 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.88] tracking-tighter">
              Wellness for the <span className="italic text-[#B45309]">real</span> workforce.
            </h1>
          </div>
          <div className="col-span-12 md:col-span-4 flex items-end">
            <p className="text-[#78716C] text-lg leading-relaxed">
              Bulk licenses, workshops, and manager training. Priced to be adopted, not admired. One business day response.
            </p>
          </div>
        </motion.div>
      </section>
      <Testimonials />
      <FAQSection />
      <B2BSection />
    </main>
  );
}
